export const fixNumberCommas = (num: string) => num?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const calculateEuclideanDistance = (a: number[], b: number[]) => {
    // Calculate the Euclidean distance between two vectors
    const sumOfSquares = a.reduce((sum, val, i) => sum + (val - b[i]) ** 2, 0);
    return Math.sqrt(sumOfSquares);
};

export const normalize = (vector: number[]): number[] => {
    const norm = Math.sqrt(vector.reduce((sum, val) => sum + val * val, 0));
    return vector.map(val => val / norm);
};

/**
 * Note: qdrant automatically normalizes the vectors when adding them.
 * google: does not return normalized vectors
 * @param a
 * @param b
 * @returns
 */
export const calculateCosineSimilarity = (a?: number[], b?: number[], normalized?: boolean) => {
    if (!a?.length || !b?.length) return 0;

    const dotProduct = a.reduce((sum, val, i) => sum + val * b[i], 0); // A dot B

    const magnitudeA = normalized ? 1 : Math.sqrt(a.reduce((sum, val) => sum + val * val, 0)); // ||A||
    const magnitudeB = normalized ? 1 : Math.sqrt(b.reduce((sum, val) => sum + val * val, 0)); // ||B||
    return dotProduct / (magnitudeA * magnitudeB); // A dot B / (||A|| * ||B||)
};

/**
 * normalizing text-embedding-ada-002 similarity score
 * @param similiarity similarity value between 0.7 to 1
 * see : https://community.openai.com/t/embedding-results-scale-seems-off/278633/3
 * https://community.openai.com/t/some-questions-about-text-embedding-ada-002-s-embedding/35299/7
 */
export const normalizeSimilarityScore = (similarity: number) => {
    // Normalizing the similarity score to a range of 0 to 1
    const min = 0.7;
    const max = 0.86;
    if (!similarity || similarity < 0.7) return 0;

    return (Math.min(similarity, max - 0.02) - min) / (max - min);
};

/**
 * reverse normalizing text-embedding-ada-002 similarity score
 * @param similiarity similarity value between 0.7 to 1
 * see : https://community.openai.com/t/embedding-results-scale-seems-off/278633/3
 * https://community.openai.com/t/some-questions-about-text-embedding-ada-002-s-embedding/35299/7
 */
export const reverseNormalizeSimilarityScore = (similarity: number) => {
    // Normalizing the similarity score to a range of 0 to 1
    const min = 0.7;
    const max = 0.86;
    return similarity * (max - min) + min;
};
